import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()(() => ({}));
